<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="参数名称">
              <global-select
                :value.sync="queryParams.parameterCodeList"
                selectType="selectMultiple"
                :selectData="parameterCodeList"
                :dropdown-match-select-width="false"
                :max-tag-text-length="5"
                :max-tag-count="1"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <a-select
                v-model="queryParams.parameterLevelValueList"
                :allowClear="true"
                mode="multiple"
                :max-tag-text-length="2"
                :max-tag-count="1"
                option-label-prop="label"
              >
                <a-select-option
                  v-for="item in inventOrgNew"
                  :key="item.realValue"
                  :value="item.realValue"
                  :label="item.label"
                >{{ `${item.realValue}${item.realValue === "(全局参数)" ? "" : "-"}${item.label === "(全局参数)" ? "" : item.label}` }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpPlanParametersNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['scp:scpPlanParameters:add']">新建</a-button>
      <a-button @click="handleExport" v-hasPermi="['scp:scpPlanParameters:export']">导出</a-button>
      <a-button @click="$refs.paramterModal.show()" v-hasPermi="['scp:scpPlanParameters:list']">参数列表</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="tableList"
          :pagination="false"
          row-key="id"
          :scroll="{ x: 1200 }"
        >
          <div
            v-for="item in columns"
            :slot="item.dataIndex"
            slot-scope="text, record"
            :key="item.dataIndex"
          >
            <span v-if="item.dataIndex === 'operation'">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:scpPlanParameters:edit']">编辑</a>
              <a v-if="!isEdit || currentId !== record.id" @click="handleDelete(record)" v-hasPermi="['scp:scpPlanParameters:remove']" class="ml10">删除</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
            <span v-else-if="item.type === 'select'">
              <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
              <a-input v-if="isEdit && currentId === record.id && item.dataIndex === 'parameterValue' && !record.attribute15" v-model="record[item.dataIndex]" size="small" />
              <a-select v-if="isEdit && currentId === record.id && item.dataIndex === 'parameterValue' && record.attribute15" v-model="record[item.dataIndex]" size="small" @focus="selectFocus(item.dataIndex, record)">
                <a-select-option v-for="(col) in setArray(item.dataList)" :key="col[item.value]">{{ col[item.label] }}</a-select-option>
              </a-select>
            </span>
            <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <span v-else>{{ text }}</span>
          </div>
        </a-table> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PLAN_PARAMETERS_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="parameterValueTitle">
            <i class="toRequired">*</i>参数值
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['scp:scpPlanParameters:edit']">编辑</a>
                <a v-if="!isEdit || currentId !== text.record.id" @click="handleDelete(text.record)" v-hasPermi="['scp:scpPlanParameters:remove']" class="ml10">删除</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'select'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-input v-if="isEdit && currentId === text.record.id && item.dataIndex === 'parameterValue' && !text.record.attribute15" v-model="text.record[item.dataIndex]" size="small" />
                <a-select v-if="isEdit && currentId === text.record.id && item.dataIndex === 'parameterValue' && text.record.attribute15" v-model="text.record[item.dataIndex]" size="small" @focus="selectFocus(item.dataIndex, text.record)">
                  <a-select-option v-for="(col) in setArray(item.dataList)" :key="col[item.value]">{{ col[item.label] }}</a-select-option>
                </a-select>
              </span>
              <span v-else-if="item.type === 'text'">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text.text }}</span>
            </div>
          </template>
        </ls-api-table>

        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <plan-parameters-add
          ref="createModal"
          :inventOrg="inventOrg"
          :parameterCodeList="parameterCodeList"
          @handle-success="handleOk"
        />
        <plan-parameters-list
          ref="paramterModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpPlanParametersUpdate, apiScpPlanParametersDelete, apiScpPlanParametersParameterValueBox, apiScpPlanParametersList, apiScpPlanParametersNewExport } from '@/api/scp/planSetting/planParameters'
import PlanParametersAdd from './components/plan-parameters-add'
import PlanParametersList from './components/plan-parameters-list'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'PlanParameters',
  components: {
    DownloadModal,
    PlanParametersAdd,
    PlanParametersList
  },
  data () {
    return {
      apiScpPlanParametersNewExport,
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpPlanParametersList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      pageParams: {
        automatic: true,
        pageUrl: '/scp/scpPlanParameters/list',
        tableLoading: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        parameterCodeList: undefined,
        parameterLevelValueList: undefined
      },
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '参数名称',
          dataIndex: 'parameterName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '参数说明',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '组织',
          dataIndex: 'parameterLevelValue',
          align: 'center'
        },
        {
          // title: '参数值',
          customTitle: '参数值',
          dataIndex: 'parameterValue',
          scopedSlots: { customRender: 'parameterValue', title: "parameterValueTitle" },
          width: 170,
          align: 'center',
          type: "select",
          dataList: 'parameterValueList',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      parameterCodeList: [], // 参数名称
      parameterValueList: [], // 参数值
      inventOrgNew: [] // 组织
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.getLookupList('SCP_PLAN_PARAMETERS', 'parameterCodeList')
    const arr = JSON.parse(JSON.stringify(this.inventOrg))
    arr.unshift({ realValue: '(全局参数)', label: '(全局参数)' })
    this.inventOrgNew = arr
  },
  mounted () {
    this.onSearch()
  },
  methods: {
     // 表单搜索
     onSearch () {
      this.isEdit = false;
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 删除
    handleDelete (row) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 id为${row.id}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpPlanParametersDelete(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.parameterValue) {
        this.$message.error('参数值不能为空')
        return
      }
      apiScpPlanParametersUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.isEdit = false
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    /** 查询列表 */
    getList (data) {
      this.tableList = data
      this.isEdit = false
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        parameterCodeList: undefined,
        parameterLevelValueList: undefined
      }
      this.handleQuery()
    },
    // 参数值
    selectFocus (dataIndex, record) {
      if (dataIndex === "parameterValue") {
        this.getParameterValueBox(record)
      }
    },
    setArray (arr) {
      return this[arr]
    },
    // 参数值-下拉框
    getParameterValueBox (record) {
      apiScpPlanParametersParameterValueBox({ parameterCode: record.parameterCode }).then(res => {
        if (res.data && res.data.length > 0) {
          this.parameterValueList = res.data
        }
      })
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('scp/scpPlanParameters/export', {
      //   ...this.queryParams
      // }, `计划参数_${new Date().getTime()}.xlsx`)
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.page-header-content{
  /deep/.ant-select{
    width: 150px;
  }
}
</style>
